import React from 'react';

import styles from './SwitchInput.module.css';

type Props = {
  children: React.ReactNode;
};

export const SwitchInputWrapper: React.FC<Props> = ({ children }) => {
  return <div className={styles.SwitchInput__Wrapper}>{children}</div>;
};
